// import React, { ReactNode, useState } from 'react';
// import './style.scss';
// import { UnitInput, UnitInputPosition } from '../../../unitInput';
// import { UnitSelectorPosition } from '../../../unitSelector';
// // import { Button, ButtonFill, ButtonSize } from 'views/mutual/button';
// import { InputTemplate, InputTemplateDataProps } from '../../../inputTemplate';
// import { CheckInput, CheckInputDataProps } from '../../../checkInput';
// import { UnitSelector } from '../../../unitSelector';
// import { CommonData } from '../../../common';
// import { SelectorDataProps } from '../../../selector';
// import { MultiSelections, Direction } from 'views/mutual/inputRadio';
// // import { AddressInfo, useBankDetailsInput } from './hook';
// import { icons } from 'constants/icons';
// import { IconColor, IconSize, SvgIcon } from 'views/mutual/svgIcon';
// import { useMessageModal } from 'views/mutual/modal/messageModal/hooks';
// import { MessageModalButtonProps,  } from 'views/mutual/modal/messageModal';
// import { ModalBase, ModalBaseProps, ModalStyle } from 'views/mutual/modal/';
// import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
// import { ITExplanationModalStep, BankStepProps } from '../hooks';
// import { SelectBankType, useSelectBank, useSelectBranch } from './hooks';
// import { BankButton, Title, Selected, Message, BankButtonProps } from '../module';
// import { FormikProps } from 'formik';

import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { ITExplanationModalStep } from '../hooks';

type ItDisClosureViaWebConferenceProps = {
  setModalStep: (agreeType: number, step: ITExplanationModalStep) => void;
};

export const ItDisClosureViaWebConference = ({ setModalStep }: ItDisClosureViaWebConferenceProps) => {
  return (
    <div className="itExplanation-modal_itDisClosureViaWebConference">
      <div className="itExplanation-modal_itDisClosureViaWebConference_title">
        {'ウェブ会議システムを使用した重要事項説明（IT重説）について'}
      </div>
      <div className="itExplanation-modal_itDisClosureViaWebConference_label">{`
　IT重説において弊社が用いる情報ツールは原則として「Google Meet」としますが、お客様において当該情報ツールの使用が困難な場合は、「Zoom」、「Microsoft Teams」、「Skype」又は「Webex Meetings」とすることも可能です 。
　説明の開始前に、宅地建物取引士が、説明の相手方の重要事項説明書及び添付書類の準備とIT環境を確認いたします。また、宅地建物取引士が宅地建物取引士証を提示し、お客様が当該取引士証を画面上で視認できたことを確認いたします 。
　IT重説の承諾にかかわらず、IT重説の実施途中に、情報ツールのトラブル等により、宅地建物取引士及びお客様がIT重説に必要なIT環境が用意できなくなった場合や、お客様において重要事項説明の内容が理解できない場合、IT重説を中断します。IT重説を開始した後であっても、承諾を撤回することが可能です。IT重説の中断や承諾撤回後の実施方法については、弊社とお客様で改めて協議の上、決定します。改めて対面による方法により重要事項説明を行う場合、宅地建物取引士の手配状況により後日のお手続きとなることがあります 。
　宅地建物取引業法第35条第3項に規定する重要事項説明について、IT重説の方法により実施することを、上記の各項目について理解の上、承諾してください。
`}</div>
      <div className="itExplanation-modal_button">
        <Button
          type={ButtonType.Submit}
          label={'IT重説に承諾する'}
          buttonFill={ButtonFill.black}
          buttonSize={ButtonSize.medium}
          onClick={() => {
            setModalStep(2, ITExplanationModalStep.IT_DISCLOSURE_APPLICATION_DATE_SELECTION);
          }}
        />
      </div>
    </div>
  );
};
